// Mont Alpi configurator — chunk 2b-revision controller.
// Resolution model: combined island SKU preferred, else compose base island +
// color-correct standalone module lines (via resolver.resolveBuild). Modules grey
// out ONLY for genuine finish constraints (KEG/KAM not on Black, FC not on
// Original) — composable modules never grey, worst case they compose. Persistent
// hero shows the combined image, or the base island + real module thumbnails when
// composed. Review tab + real upsell + multi-line add-to-cart are 2c.

const FINISH_ORDER = ["Original", "Deluxe", "Black"];
const FINISH_COPY = {
  Original: "Brushed 304 stainless throughout — the classic look. Island only.",
  Deluxe:   "Premium stainless with waterfall granite composite ends and the full accessory kit.",
  Black:    "Bold black stainless for a modern outdoor kitchen, full kit included.",
};
const SIZES = [{ value: 4, label: "4-Burner", sub: "Compact footprint" }, { value: 6, label: "6-Burner", sub: "Full-size flagship" }];
const SHAPES = [{ value: "Straight", label: "Straight", sub: "In-line" }, { value: "L", label: "L-shape", sub: "90° corner" }, { value: "V", label: "V-shape", sub: "45° angle" }];
const REF_TOGGLES = ["BEV", "KEG"];          // Beverage Center above Kegerator
const STORAGE_TOGGLES = ["DR", "XL", "KAM"];
const MOD_SUB = { BEV: "Sink + undercounter fridge", KEG: "Tap & keg", DR: "Triple drawers", XL: "Door storage w/ shelves", KAM: "Houses a kamado", FC: "Built-in fridge cabinet" };
// Approx width (inches) a module adds when it attaches as its own side-by-side line,
// read off each module's spec diagram (DR/XL/KAM confirmed vs grill_width metafield;
// KEG/BEV from the labeled diagram). FC is substitutive (replaces the right cabinet) — never a line.
const MODULE_WIDTH = { DR: 25, XL: 25, KEG: 48, BEV: 38, KAM: 33 };
const TAB_ORDER = ["finish", "sizeshape", "refstorage", "accessories", "review"];
const PREVIEW_FINISH = "Deluxe", PREVIEW_SIZE = 6;
const SHAPE_WORD = { Straight: "Straight", L: "L-shape", V: "V-shape" };
// Item 2: these SKUs stay in the PAID accessories list even while they're active
// free gifts — a customer can pick one free AND buy another (gift uses the $0
// *-GIFT variant; paid uses the real variant → separate cart lines). The gift
// carve-out still suppresses any OTHER gift SKU from the paid list.
const ALWAYS_PURCHASABLE_GIFT_SKUS = new Set(["MAPZ-SS", "MASHP"]);
const LS_KEY = "montAlpiBuild:v1";   // item 7: localStorage persistence key

const usd = (v) => { const n = Number(v); return Number.isFinite(n) ? "$" + n.toLocaleString("en-US", { maximumFractionDigits: 0 }) : ""; };
const cleanTitle = (t) => String(t || "").replace(/\s*-\s*MA[Bbi]?\w[\w-]*\s*$/i, "").trim();
const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const toggleSet = (arr, m) => (arr.includes(m) ? arr.filter((x) => x !== m) : [...arr, m]);
const withoutFC = (arr) => arr.filter((x) => x !== "FC");
const withFC = (arr) => (arr.includes("FC") ? arr : [...arr, "FC"]);

(async function () {
  const root = document.getElementById("mont-alpi-configurator");
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const hero = {
    media: $("[data-hero-media]"), img: $("[data-hero-img]"), granite: $("[data-hero-granite]"),
    thumbs: $("[data-hero-thumbs]"), title: $("[data-hero-title]"), price: $("[data-hero-price]"), breakdown: $("[data-hero-breakdown]"),
    note: $("[data-hero-note]"), caption: $("[data-hero-caption]"), sku: $("[data-hero-sku]"), adjust: $("[data-hero-adjust]"),
  };
  const finishesEl = $("[data-finishes]"), sizesEl = $("[data-sizes]"), shapesEl = $("[data-shapes]"), fuelEl = $("[data-fuel]");
  const dimsEl = $("[data-dims]"), dimsImg = $("[data-dims-img]"), dimsCap = $("[data-dims-cap]"), dimsNotes = $("[data-dims-notes]");
  // Content section below the configurator (separate section, same page): the
  // build-aware spec/dimensions table + the module deep-explainer. Both are fed
  // from the catalog/resolver this controller already loaded — no Admin API call.
  const specsEl = document.querySelector("[data-ma-specs]"), modulesEl = document.querySelector("[data-ma-modules]");
  const cabinetEl = $("[data-cabinet]"), refEl = $("[data-modules-ref]"), storageEl = $("[data-modules-storage]");
  const giftEl = $("[data-gift]"), giftOptsEl = $("[data-gift-opts]"), giftTitleEl = $("[data-gift-title]"), accEl = $("[data-accessories]");
  const reviewEl = $("[data-review]"), reviewFoot = $("[data-review-foot]"), reviewTotalEl = $("[data-review-total]"), reviewBreakdownEl = $("[data-review-breakdown]"), reviewMsgEl = $("[data-review-msg]"), upsellEl = $("[data-upsell]"), addBtn = $("[data-add-to-cart]");

  // Free-gift program config is rendered server-side from shop metafields
  // (gift_program.enabled + gift_program.options → "Free Gift Option" metaobjects).
  // Absent/false metafields => { enabled:false, gifts:[] } and the gift UI stays hidden.
  let giftConfig = { enabled: false, freeCount: 1, gifts: [] };
  try {
    const cfgEl = $("[data-gift-config]");
    if (cfgEl) { const parsed = JSON.parse(cfgEl.textContent); if (parsed && typeof parsed === "object") giftConfig = parsed; }
  } catch (e) { console.warn("[MontAlpi] gift config parse failed", e); }
  const giftFreeCount = Number(giftConfig.freeCount) > 0 ? Number(giftConfig.freeCount) : 1;
  const stepBtns = Array.from(root.querySelectorAll("[data-step]"));
  const panels = Array.from(root.querySelectorAll("[data-panel]"));
  const navPrev = $('[data-nav="prev"]'), navNext = $('[data-nav="next"]'), navReset = $('[data-nav="reset"]');

  // Defaults: 6-burner + Straight + Propane (flagship/most common), freely changeable.
  const DEFAULTS = { size: 6, shape: "Straight", fuel: "propane" };
  // gift = selected free-gift SKU (or null); accessories = selected paid-accessory
  // SKUs. Both feed the Review tab (2c-3) + multi-line add-to-cart.
  const state = { finish: null, size: DEFAULTS.size, shape: DEFAULTS.shape, modules: [], fuel: DEFAULTS.fuel, gift: null, accessories: [], cover: false };
  let adjustMsg = "";
  let lastGrand = null; // last rendered grand total, for the subtle change pulse
  // Item 5: the series the customer was on BEFORE clicking an upsell "Upgrade"
  // switch — so the Review step can offer an explicit one-click undo back to it.
  // Null unless they actually upgraded (never offered to people who started on
  // Deluxe/Black, so no Original downsell is ever surfaced).
  let preUpgradeFinish = null;

  let resolver, FINISHES, MODULE_DEFS, FINISH_COLOR;
  try {
    const mod = await import(root.dataset.resolverUrl);
    FINISHES = mod.FINISHES; MODULE_DEFS = mod.MODULE_DEFS; FINISH_COLOR = mod.FINISH_COLOR;
    const catalog = await (await fetch(root.dataset.catalogUrl)).json();
    resolver = mod.createResolver(catalog);
    window.MontAlpiConfigurator = resolver; window.MontAlpiState = state;
  } catch (err) {
    console.error("[MontAlpi] init failed", err);
    if (finishesEl) finishesEl.innerHTML = '<p class="ma-cfg__loading">Configurator is temporarily unavailable.</p>';
    return;
  }

  const ready = () => Boolean(state.finish && state.size);
  const sel = (over = {}) => ({ finish: state.finish, size: state.size, shape: state.shape, modules: state.modules, fuel: state.fuel, ...over });
  const buildFor = (over) => resolver.resolveBuild({ finish: state.finish || PREVIEW_FINISH, size: state.size || PREVIEW_SIZE, shape: state.shape || "Straight", modules: state.modules, fuel: state.fuel, ...over });

  // Greyed options use a hoverable class (not native [disabled]) so tooltips fire.
  const GATE_TIP = "Choose a finish first to start your build.";
  const off = (el, isOff) => { el.classList.toggle("ma-off", isOff); el.setAttribute("aria-disabled", isOff ? "true" : "false"); };
  const isOff = (el) => el.getAttribute("aria-disabled") === "true";
  const setTip = (el, text) => { if (text) el.setAttribute("data-tooltip", text); else el.removeAttribute("data-tooltip"); };
  // Color-matched module image: same finish-family logic that picks the SKU
  // (Original/Deluxe -> -SS image, Black -> -BSS image). Falls back to the
  // stainless image for finishes that don't offer a module (shown greyed).
  const moduleImage = (finish, token) => {
    const d = MODULE_DEFS[token]; if (!d) return null;
    const color = FINISH_COLOR[finish || PREVIEW_FINISH] || "SS";
    const sku = d.skus[color] || d.skus.SS || d.skus.BSS;
    return resolver.moduleProducts[sku]?.heroImage || null;
  };

  // ---- item 3: tooltips (bigger image + explainer) --------------------------
  // Content is pulled from the SAME catalog product data the tiles already use, by
  // SKU — so MAPZ-SS / MASHP resolve to identical image+text whether shown in the
  // gift picker OR the paid accessories list (both go through accTip()).
  // Module tooltip text = the SAME bespoke lede shown on the "Explore the modules"
  // cards (MODULE_LEDE, defined below) — single source, no truncated descriptionHtml.
  // Image stays finish-color-matched. Only modules with a bespoke lede get a tip.
  const modTip = (finish, token) => {
    const def = MODULE_DEFS[token], lede = MODULE_LEDE[token];
    return def && lede ? { img: moduleImage(finish, token), title: def.label, text: lede } : null;
  };
  // Accessory/gift tooltip = the accessory's short CLEAN explainer (its blurb) + image
  // — never the raw, truncated product description. Same object drives both the paid
  // tile and the gift picker (resolver.accessories(), keyed by SKU), so MAPZ-SS /
  // MASHP read identically in both placements.
  const accTipBy = (acc) => acc ? { img: acc.image, title: acc.label, text: acc.blurb } : null;
  const COVER_TIP = "A weatherproof cover cut to your exact island layout — it fits snugly over the grill, modules and countertops to shield the stainless and granite composite from sun, rain and debris when the island isn't in use.";
  const coverTip = (cover) => cover && cover.image ? { img: cover.image, title: "Custom-fit island cover", text: COVER_TIP } : null;
  // Trigger + panel markup (content baked in). Empty when there's nothing to show.
  const tipMarkup = (c) => (!c || (!c.text && !c.img)) ? "" :
    `<span class="ma-tip-trigger" data-tip role="button" tabindex="0" aria-label="More information">i</span><span class="ma-tip" role="tooltip">${c.img ? `<img class="ma-tip__img" loading="lazy" src="${esc(c.img)}" alt="">` : ""}<span class="ma-tip__text">${c.title ? `<strong>${esc(c.title)}</strong>` : ""}${c.text ? `<span>${esc(c.text)}</span>` : ""}</span></span>`;
  // Populate a once-built tile's tooltip (modules/fridge change image by finish).
  const fillTip = (tileEl, c) => {
    const trig = tileEl.querySelector(".ma-tip-trigger"), panel = tileEl.querySelector(".ma-tip");
    if (!trig || !panel) return;
    const has = c && (c.text || c.img);
    trig.hidden = !has;
    panel.innerHTML = has ? `${c.img ? `<img class="ma-tip__img" loading="lazy" src="${esc(c.img)}" alt="">` : ""}<span class="ma-tip__text">${c.title ? `<strong>${esc(c.title)}</strong>` : ""}${c.text ? `<span>${esc(c.text)}</span>` : ""}</span>` : "";
  };
  // Tap-to-toggle on touch (desktop uses CSS :hover/:focus). The info trigger lives
  // inside the tile button, so intercept its click, stop it selecting the tile.
  const closeTips = () => root.querySelectorAll(".ma-tip-trigger.is-tip-open").forEach((t) => t.classList.remove("is-tip-open"));
  const handleTip = (e) => {
    const trig = e.target.closest("[data-tip]"); if (!trig) return false;
    e.preventDefault(); e.stopPropagation();
    const wasOpen = trig.classList.contains("is-tip-open");
    closeTips();
    if (!wasOpen) trig.classList.add("is-tip-open");
    return true;
  };
  document.addEventListener("click", (e) => { if (!e.target.closest("[data-tip]") && !e.target.closest(".ma-tip")) closeTips(); });

  // THE single source of truth for the order — hero, Review, and add-to-cart all
  // read this from the SHARED state so the displayed total, the Review total, and
  // the cart can't drift. Returns the full ordered line set (each with a real
  // variantId pulled live from the catalog/metaobject), the island/accessories
  // subtotals, the grand total (free lines excluded), and any unresolved lines.
  const giftSkuSet = () => new Set(giftConfig.enabled && Array.isArray(giftConfig.gifts) ? giftConfig.gifts.map((g) => g && g.sku).filter(Boolean) : []);
  function composeOrder() {
    const o = { islandLines: [], moduleLines: [], freeLines: [], accessoryLines: [], coverLine: null, giftLine: null,
      islandSubtotal: 0, accessoriesSubtotal: 0, total: 0, cartLines: [], unresolved: [], build: null };
    if (!ready()) return o;
    const build = resolver.resolveBuild(sel());
    o.build = build;
    for (const l of build.lines) {
      if (l.free) o.freeLines.push(l);            // MANGK ($0 variant), free
      else if (l.kind === "island") o.islandLines.push(l);
      else if (l.kind === "module") o.moduleLines.push(l);
    }
    o.islandSubtotal = build.total || 0;          // island + modules (free lines excluded by resolveBuild)
    const giftSkus = giftSkuSet();
    const bySku = new Map(resolver.accessories(state.finish).map((a) => [a.sku, a]));
    for (const sku of state.accessories) {
      const a = bySku.get(sku);
      if (a && !a.suppressed && a.available && a.price != null && (!giftSkus.has(sku) || ALWAYS_PURCHASABLE_GIFT_SKUS.has(sku)))
        o.accessoryLines.push({ kind: "accessory", sku: a.sku, label: a.label, title: a.title || a.label, price: a.price, variantId: a.variantId, image: a.image });
    }
    if (state.cover) {
      const cv = resolver.resolveCover(sel());
      if (cv && !cv.suppressed && cv.available && cv.price != null)
        o.coverLine = { kind: "cover", sku: cv.sku, label: "Custom-Fit Island Cover", title: cv.title || "Island cover", price: cv.price, variantId: cv.variantId, image: cv.image };
    }
    o.accessoriesSubtotal = o.accessoryLines.reduce((s, l) => s + l.price, 0) + (o.coverLine ? o.coverLine.price : 0);
    o.total = o.islandSubtotal + o.accessoriesSubtotal;
    if (state.gift) {
      const g = (giftConfig.gifts || []).find((x) => x && x.sku === state.gift);
      if (g) o.giftLine = { kind: "gift", sku: g.sku, label: g.title || g.sku, title: g.title || g.sku, price: 0, free: true, variantId: g.variantId || null, image: g.image, strike: g.strike };
    }
    const cart = [...o.islandLines, ...o.moduleLines, ...o.freeLines, ...o.accessoryLines];
    if (o.coverLine) cart.push(o.coverLine);
    if (o.giftLine) cart.push(o.giftLine);
    o.cartLines = cart;
    o.unresolved = cart.filter((l) => !l.variantId).map((l) => l.sku || l.label || l.kind);
    return o;
  }

  // ---- persistent hero ------------------------------------------------------
  function renderHero() {
    const chosen = ready();
    const build = chosen ? resolver.resolveBuild(sel()) : buildFor({ modules: [] });
    const img = build.hero && build.hero.image;
    if (hero.img && img && hero.img.getAttribute("src") !== img) {
      hero.media.classList.add("is-swapping");
      const s = new Image(); s.onload = () => { hero.img.src = img; hero.media.classList.remove("is-swapping"); }; s.src = img;
      hero.img.alt = cleanTitle(build.lines?.[0]?.title);
    }
    const finishLabel = FINISHES[state.finish || PREVIEW_FINISH]?.label || "";
    hero.title.textContent = chosen ? buildTitle(build) : "Your Mont Alpi island";

    // Running build total from the shared order (same source as Review + cart).
    const order = chosen ? composeOrder() : null;
    const islandBase = build.total;
    const accSub = order ? order.accessoriesSubtotal : 0;
    const grand = order ? order.total : (islandBase != null ? islandBase : null);
    if (grand != null) {
      hero.price.innerHTML = `${usd(grand)} <small>${chosen ? "" : "starting"}</small>`;
      if (lastGrand != null && grand !== lastGrand) { // subtle pulse on change, no jump
        hero.price.classList.remove("is-bumped"); void hero.price.offsetWidth; hero.price.classList.add("is-bumped");
      }
    } else hero.price.innerHTML = "";
    lastGrand = grand;
    // Breakdown under the total — secondary to the big number. "Accessories" matches
    // the right-column header (never "add-ons").
    if (chosen && islandBase != null) {
      hero.breakdown.hidden = false;
      hero.breakdown.innerHTML = `Island ${usd(islandBase)} <span class="ma-cfg__hero-dot" aria-hidden="true">·</span> Accessories ${usd(accSub)}`;
    } else { hero.breakdown.hidden = true; hero.breakdown.innerHTML = ""; }

    hero.granite.hidden = !(build.finish && build.finish.granite);     // clears whenever finish != Deluxe

    const thumbs = (chosen && build.composed && build.hero.moduleThumbs.length) ? build.hero.moduleThumbs : [];
    hero.thumbs.hidden = thumbs.length === 0;
    if (thumbs.length) {
      const cell = (image, label) => `<span class="ma-cfg__thumb">${image ? `<img loading="lazy" src="${esc(image)}" alt="">` : ""}<span>${esc(label)}</span></span>`;
      const parts = [cell(build.hero.image, "Island")];
      thumbs.forEach((t) => { parts.push('<span class="ma-cfg__plus" aria-hidden="true">+</span>', cell(t.image, t.label)); });
      hero.thumbs.innerHTML = parts.join("");
    } else hero.thumbs.innerHTML = "";
    hero.caption.hidden = thumbs.length === 0;
    if (thumbs.length) hero.caption.textContent = "Configured build — your island plus the matching modules shown.";

    if (chosen) {
      const modNames = state.modules.map((m) => MODULE_DEFS[m]?.label || m);
      const fuelTxt = state.fuel === "ng" ? " · Natural Gas" : "";
      hero.note.innerHTML = `<strong>${esc(finishLabel)}</strong> · ${state.size}-burner · ${esc(SHAPE_WORD[state.shape])}${modNames.length ? ` · ${esc(modNames.join(", "))}` : ""}${fuelTxt}`;
      hero.sku.hidden = false;
      const skuParts = build.lines.map((l) => l.sku + (l.free ? " (free)" : ""));
      hero.sku.textContent = (build.composed || build.lines.length > 1) ? `Builds from: ${skuParts.join(" + ")}` : `SKU: ${build.sku}`;
    } else {
      hero.note.innerHTML = `Pick a finish to start your build. This is a <strong>${esc(finishLabel)}</strong> preview.`;
      hero.sku.hidden = true;
    }
    hero.adjust.hidden = !adjustMsg; hero.adjust.innerHTML = adjustMsg;
  }
  function buildTitle(build) {
    if (!build.composed && build.lines[0]) return cleanTitle(build.lines[0].title);
    const f = FINISHES[state.finish]?.label || "";
    return `${f} ${state.size}-Burner Island${state.shape !== "Straight" ? `, ${SHAPE_WORD[state.shape]}` : ""}`;
  }

  // Dimensions diagram for the Fuel/Size/Shape step — the island product's SECOND
  // image (specImage = images[1], the spec sheet) for the current build. Resolves
  // off the live build so it tracks size/shape (and the combined SKU when one
  // exists); falls back to a preview build before a finish is chosen so a diagram
  // is always shown while choosing the physical config.
  function renderDimensions() {
    if (!dimsEl) return;
    const build = ready() ? resolver.resolveBuild(sel()) : buildFor({ modules: [] });
    const img = build.hero && build.hero.specImage;
    if (!img) { dimsEl.hidden = true; return; }
    dimsEl.hidden = false;
    if (dimsImg.getAttribute("src") !== img) dimsImg.src = img;
    const label = `${state.size}-burner · ${SHAPE_WORD[state.shape]}`;
    dimsImg.alt = `Mont Alpi ${label} island dimensions diagram`;
    if (dimsCap) dimsCap.textContent = label;
    // The diagram is the canonical island's footprint. When the build composes that
    // island + extra modules as separate lines, those modules add width side-by-side
    // — note each one's approximate added width (the diagram doesn't include them).
    if (dimsNotes) {
      const adds = (build.lines || []).filter((l) => l.kind === "module" && MODULE_WIDTH[l.token]);
      dimsNotes.innerHTML = adds.map((l) => `<li>${esc(l.label || MODULE_DEFS[l.token]?.label || l.token)} adds ~${MODULE_WIDTH[l.token]}" of width</li>`).join("");
    }
  }

  // Build-aware specifications + dimensions table in the content section. Reuses
  // the same live-build resolution as the hero/dimensions: the resolved island's
  // physical specs (canonical product, or the base island when composed). Renders
  // only the rows that carry data; hides entirely if the resolved island has none.
  function renderSpecs() {
    if (!specsEl) return;
    const build = ready() ? resolver.resolveBuild(sel()) : buildFor({ modules: [] });
    const specs = build && build.specs;
    if (!specs || (!(specs.spec || []).length && !(specs.dims || []).length)) { specsEl.hidden = true; specsEl.innerHTML = ""; return; }
    const finishLabel = FINISHES[state.finish || PREVIEW_FINISH]?.label || "";
    const ctx = `${finishLabel} · ${state.size}-burner · ${SHAPE_WORD[state.shape]}`;
    const table = (rows) => `<table class="ma-specs__table"><tbody>${rows.map(([k, v]) => `<tr><td>${esc(k)}</td><td>${esc(v)}</td></tr>`).join("")}</tbody></table>`;
    const card = (title, rows) => rows.length ? `<div class="ma-specs__card"><h3>${esc(title)}</h3>${table(rows)}</div>` : "";
    specsEl.hidden = false;
    specsEl.innerHTML = `<h2 class="ma-content__h2">Specifications &amp; dimensions</h2>
      <div class="ma-specs__grid">${card("Specifications", specs.spec || [])}${card("Dimensions", specs.dims || [])}</div>
      <p class="ma-specs__cap">For your current build — <strong>${esc(ctx)}</strong>${ready() ? "" : " (preview)"}. Updates as you change size, shape, and finish above.</p>`;
  }

  // Module deep-explainer — one card per module. The lede is BESPOKE, authored copy
  // (the pulled product descriptions truncated mid-sentence); the feature chips +
  // image are still pulled live from the module product (catalog). Static
  // (build-independent): a customer deciding on a module can read what it is and why.
  const MODULE_LEDE = {
    BEV: "An outdoor-rated refrigerator with an integrated sink and faucet — keep drinks cold and rinse hands, produce, or glassware without a trip indoors. Adjustable shelving and six cooling settings handle everything from cans to bottles, so the party stays at the island.",
    KEG: "Pour draft beer straight from your island with a three-tap kegerator that holds up to three slim kegs at once. A digital display keeps the temperature dialed in, and the tiered top with built-in tray keeps spills and foam under control.",
    FC:  "A built-in refrigerator that replaces your island’s standard right cabinet — no extra footprint required. With 90-can capacity, three adjustable shelves, and six cooling settings, drinks and ingredients stay within arm’s reach of the grill. (Available on Deluxe and Black series.)",
    DR:  "Three soft-close stainless drawers that bring real organization to your outdoor kitchen — tools, utensils, and grilling gear sorted and weatherproof beside the grill. Smooth-glide hardware and a granite composite top tie it into the rest of the island.",
    XL:  "A versatile storage cabinet that adds enclosed space for accessories, covers, and anything you’d rather keep out of the weather. It fits between modules on the right side of the grill for a clean, seamless look.",
    KAM: "A stainless housing that integrates a charcoal kamado into your island, so you can sear, smoke, and grill low-and-slow alongside your gas burners. Sized to fit kamado grills up to 18.5 inches, it brings true charcoal flavor to your outdoor kitchen — the housing only; you supply the kamado grill.",
  };
  // Caveats that must read as a warning, NOT a feature (visually distinct red chip).
  const MODULE_CAVEAT = { KAM: "Kamado grill not included" };
  function renderModuleExplainer() {
    if (!modulesEl) return;
    const ORDER = [["BEV", "Refrigeration"], ["KEG", "Refrigeration"], ["FC", "Refrigeration"], ["DR", "Storage"], ["XL", "Storage"], ["KAM", "Cooking"]];
    const cards = ORDER.map(([token, cat]) => {
      const def = MODULE_DEFS[token]; if (!def) return "";
      const sku = def.skus.SS || def.skus.BSS; const p = resolver.moduleProducts[sku] || {};
      const lede = MODULE_LEDE[token];
      if (!lede && !(p.features || []).length) return "";   // nothing to show — skip
      const feats = (p.features || []).slice(0, 6).map((f) => `<li>${esc(f)}</li>`).join("");
      // Caveat as a chip INSIDE the features flow (a red pill), so it wraps inline
      // with the feature chips instead of forcing its own full-width row above them.
      const caveatChip = MODULE_CAVEAT[token] ? `<li class="ma-modx__caveat"><span aria-hidden="true">⚠</span> ${esc(MODULE_CAVEAT[token])}</li>` : "";
      return `<div class="ma-modx">
        <div class="ma-modx__media">${p.heroImage ? `<img loading="lazy" src="${esc(p.heroImage)}" alt="${esc(def.label)}">` : ""}</div>
        <div class="ma-modx__body">
          <p class="ma-modx__cat">${esc(cat)}</p>
          <h3 class="ma-modx__name">${esc(def.label)}</h3>
          ${lede ? `<p class="ma-modx__desc">${esc(lede)}</p>` : ""}
          ${(caveatChip || feats) ? `<ul class="ma-modx__features" role="list">${caveatChip}${feats}</ul>` : ""}
        </div></div>`;
    }).filter(Boolean).join("");
    if (!cards) { modulesEl.hidden = true; return; }
    modulesEl.hidden = false;
    modulesEl.innerHTML = `<h2 class="ma-content__h2">Explore the modules</h2>
      <p class="ma-mods__intro">Mont Alpi islands are modular — add refrigeration, storage, and cooking modules to build your ideal outdoor kitchen. Here's what each one brings.</p>
      <div class="ma-mods__list">${cards}</div>`;
  }

  // ---- renderers ------------------------------------------------------------
  function finishTile(series) {
    const meta = FINISHES[series]; if (!meta) return "";
    const rep = resolver.resolve({ finish: series, size: PREVIEW_SIZE, shape: "Straight", modules: [] });
    const img = rep.mode === 1 && rep.product ? rep.product.heroImage : null;
    const from = resolver.startingAt(series);
    const inc = meta.includes || [];
    const metaRow = inc.length
      ? `<div class="ma-finish__meta">${inc.map((i) => `<span class="ma-finish__pill">${esc(i)}</span>`).join("")}${meta.granite ? `<span class="ma-finish__granite">Waterfall granite composite ends</span>` : ""}</div>`
      : `<div class="ma-finish__meta"><span class="ma-finish__only">Island only — add accessories any time</span></div>`;
    return `<button type="button" class="ma-finish" data-finish="${series}" aria-pressed="false">
      <span class="ma-finish__thumb">${img ? `<img loading="lazy" src="${esc(img)}" alt="">` : ""}</span>
      <span class="ma-finish__body">
        <span class="ma-finish__top"><span class="ma-finish__name">${esc(meta.label)}</span><span class="ma-finish__check" aria-hidden="true">✓</span></span>
        <span class="ma-finish__desc">${esc(FINISH_COPY[series] || "")}</span>${metaRow}
        ${from != null ? `<span class="ma-finish__from">from ${usd(from)}</span>` : ""}
      </span></button>`;
  }
  finishesEl.innerHTML = FINISH_ORDER.map(finishTile).join("");

  const optTile = (axis, o) => `<button type="button" class="ma-opt" data-${axis}="${o.value}" aria-pressed="false">
    <span class="ma-opt__top"><span class="ma-opt__label">${esc(o.label)}</span><span class="ma-opt__check" aria-hidden="true">✓</span></span>
    <span class="ma-opt__sub">${esc(o.sub)}</span><span class="ma-opt__price" data-price></span></button>`;
  sizesEl.innerHTML = SIZES.map((o) => optTile("size", o)).join("");
  shapesEl.innerHTML = SHAPES.map((o) => optTile("shape", o)).join("");

  cabinetEl.innerHTML = `
    <button type="button" class="ma-cab" data-cab="standard" aria-pressed="true"><span class="ma-cab__label">Storage cabinet</span><span class="ma-cab__sub">Standard right cabinet</span></button>
    <button type="button" class="ma-cab ma-cab--fridge" data-cab="fridge" aria-pressed="false">
      <span class="ma-cab__thumb"><img data-thumb loading="lazy" alt=""></span>
      <span class="ma-cab__body"><span class="ma-cab__label">Fridge cabinet<span class="ma-tip-trigger" data-tip role="button" tabindex="0" aria-label="More information" hidden>i</span><span class="ma-tip" role="tooltip"></span> <span class="ma-cab__delta" data-price></span></span><span class="ma-cab__sub" data-sub>Built-in fridge replaces the storage cabinet</span></span></button>`;

  // KAM is a HOUSING only — the kamado grill itself isn't included. This caveat is
  // ALWAYS visible on the tile at the point of selection (not a tooltip that can be
  // clicked past), so the customer can't add it without seeing it.
  const MOD_CAVEAT = { KAM: "Housing only — you supply the kamado grill (18.5″ cooking diameter or smaller)" };
  const modTile = (m) => `<button type="button" class="ma-mod" data-mod="${m}" aria-pressed="false">
    <span class="ma-mod__thumb"><img data-thumb loading="lazy" alt=""></span>
    <span class="ma-mod__body"><span class="ma-mod__label">${esc(MODULE_DEFS[m]?.label || m)}<span class="ma-tip-trigger" data-tip role="button" tabindex="0" aria-label="More information" hidden>i</span><span class="ma-tip" role="tooltip"></span></span><span class="ma-mod__sub" data-sub>${esc(MOD_SUB[m] || "")}</span>${MOD_CAVEAT[m] ? `<span class="ma-mod__caveat">⚠ ${esc(MOD_CAVEAT[m])}</span>` : ""}</span>
    <span class="ma-mod__price" data-price></span><span class="ma-mod__box" aria-hidden="true">✓</span></button>`;
  refEl.innerHTML = REF_TOGGLES.map(modTile).join("");
  storageEl.innerHTML = STORAGE_TOGGLES.map(modTile).join("");

  // ---- Gift & Accessories tab ----------------------------------------------
  // SKUs already bundled into the chosen series (e.g. MAROTIS on Deluxe/Black) —
  // never offered as a paid accessory OR auto-eligible as a free gift.
  const suppressedSkus = () => new Set(resolver.accessories(state.finish).filter((a) => a.suppressed).map((a) => a.sku));

  function renderGift() {
    const supp = suppressedSkus();
    const gifts = (giftConfig.enabled && Array.isArray(giftConfig.gifts) ? giftConfig.gifts : [])
      .filter((g) => g && g.sku && !supp.has(g.sku));         // never a gift that's already included
    const show = giftConfig.enabled && gifts.length > 0 && ready();
    giftEl.hidden = !show;
    // Drop a stale selection (program off, build not ready, gift now suppressed/removed).
    if (state.gift && (!show || !gifts.some((g) => g.sku === state.gift))) state.gift = null;
    if (!show) { giftOptsEl.innerHTML = ""; return; }
    giftTitleEl.textContent = gifts.length > 1 ? `Choose your free gift — pick ${giftFreeCount}` : "Your free gift, on us";
    const accBy = new Map(resolver.accessories(state.finish).map((a) => [a.sku, a])); // gift tip = same source as paid
    giftOptsEl.innerHTML = gifts.map((g) => {
      const on = state.gift === g.sku;
      const was = g.strike != null && g.strike !== "" ? `<span class="ma-gift__was">${usd(g.strike)}</span>` : "";
      return `<button type="button" class="ma-gift__opt" data-giftsku="${esc(g.sku)}" role="radio" aria-checked="${on}">
        <span class="ma-gift__radio" aria-hidden="true"></span>
        <span class="ma-gift__thumb">${g.image ? `<img loading="lazy" src="${esc(g.image)}" alt="">` : ""}</span>
        <span class="ma-gift__info"><span class="ma-gift__name">${esc(g.title || g.sku)}${tipMarkup(accTipBy(accBy.get(g.sku)))}</span>
          <span class="ma-gift__price"><span class="ma-gift__free">FREE</span>${was}</span></span></button>`;
    }).join("");
  }

  function renderAccessories() {
    // Carve-out: while the program is on, every active gift SKU is removed from the
    // paid list so a gift is never also sold. Series-suppressed + inactive + price-less drop too.
    const giftSkus = new Set(giftConfig.enabled && Array.isArray(giftConfig.gifts) ? giftConfig.gifts.map((g) => g && g.sku).filter(Boolean) : []);
    const list = resolver.accessories(state.finish)
      .filter((a) => !a.suppressed && a.available && a.price != null && (!giftSkus.has(a.sku) || ALWAYS_PURCHASABLE_GIFT_SKUS.has(a.sku)));
    state.accessories = state.accessories.filter((sku) => list.some((a) => a.sku === sku)); // prune stale picks

    // Matching cover (2c-2b): the ONE cover for this exact build, Original only
    // (bundled for Deluxe/Black -> suppressed). Tracked as a boolean since the
    // resolved SKU changes with the build; the Review tab re-resolves at consume time.
    const cover = ready() ? resolver.resolveCover(sel()) : null;
    const coverOffered = !!(cover && !cover.suppressed && cover.available && cover.price != null);
    if (!coverOffered) state.cover = false;
    const coverTile = coverOffered ? `<button type="button" class="ma-mod ma-acc ma-acc--cover" data-cover="1" aria-pressed="${state.cover}">
        <span class="ma-mod__thumb">${cover.image ? `<img loading="lazy" src="${esc(cover.image)}" alt="">` : ""}</span>
        <span class="ma-mod__body"><span class="ma-mod__label">Custom-Fit Island Cover${tipMarkup(coverTip(cover))}</span><span class="ma-mod__sub">Weatherproof cover matched to your exact build${cover.sku ? ` · ${esc(cover.sku)}` : ""}</span></span>
        <span class="ma-mod__price">+${usd(cover.price)}</span><span class="ma-mod__box" aria-hidden="true">✓</span></button>` : "";

    accEl.innerHTML = coverTile + list.map((a) => {
      const on = state.accessories.includes(a.sku);
      return `<button type="button" class="ma-mod ma-acc" data-accsku="${esc(a.sku)}" aria-pressed="${on}">
        <span class="ma-mod__thumb">${a.image ? `<img loading="lazy" src="${esc(a.image)}" alt="">` : ""}</span>
        <span class="ma-mod__body"><span class="ma-mod__label">${esc(a.label)}${tipMarkup(accTipBy(a))}</span><span class="ma-mod__sub">${esc(a.blurb || "")}</span></span>
        <span class="ma-mod__price">+${usd(a.price)}</span><span class="ma-mod__box" aria-hidden="true">✓</span></button>`;
    }).join("");
  }

  // ---- Review tab (2c-3) ----------------------------------------------------
  const reviewRow = ({ img, label, sub, price, note, free }) => `<div class="ma-review__row">
      <span class="ma-review__thumb">${img ? `<img loading="lazy" src="${esc(img)}" alt="">` : ""}</span>
      <span class="ma-review__body"><span class="ma-review__label">${esc(label || "")}</span>${sub ? `<span class="ma-review__sub">${esc(sub)}</span>` : ""}${note ? `<span class="ma-review__note">${esc(note)}</span>` : ""}</span>
      <span class="ma-review__price${free ? " ma-review__price--free" : ""}">${free ? "FREE" : esc(price)}</span></div>`;

  function renderReview() {
    if (!ready()) {
      reviewEl.innerHTML = `<p class="ma-cfg__loading">Choose a finish to start your build.</p>`;
      reviewFoot.hidden = true; renderUpsell(); return;
    }
    const o = composeOrder(), b = o.build;
    const finishLabel = FINISHES[state.finish]?.label || "";
    const modNames = state.modules.map((m) => MODULE_DEFS[m]?.label || m);
    const meta = `${finishLabel} · ${state.size}-burner · ${SHAPE_WORD[state.shape]}${modNames.length ? ` · ${modNames.join(", ")}` : ""}${state.fuel === "ng" ? " · Natural Gas" : ""}`;
    const skuLine = (b.composed || b.lines.filter((l) => !l.free).length > 1)
      ? `Builds from: ${b.lines.filter((l) => !l.free).map((l) => l.sku).join(" + ")}` : `SKU ${b.sku}`;
    const rows = [reviewRow({ img: o.islandLines[0] && o.islandLines[0].image, label: cleanTitle(o.islandLines[0] && o.islandLines[0].title) || `${finishLabel} island`, sub: meta, note: skuLine, price: usd(o.islandSubtotal) })];
    o.accessoryLines.forEach((a) => rows.push(reviewRow({ img: a.image, label: a.label, sub: "Accessory", price: `+${usd(a.price)}` })));
    if (o.coverLine) rows.push(reviewRow({ img: o.coverLine.image, label: o.coverLine.label, sub: `Accessory · ${o.coverLine.sku}`, price: `+${usd(o.coverLine.price)}` }));
    if (state.fuel === "ng" && o.freeLines.length) rows.push(reviewRow({ img: o.freeLines[0].image, label: "Natural gas conversion kit", sub: "Included with Natural Gas", free: true }));
    if (o.giftLine) rows.push(reviewRow({ img: o.giftLine.image, label: o.giftLine.title, sub: "Free gift — on us", free: true }));
    reviewEl.innerHTML = rows.join("");

    reviewFoot.hidden = false;
    reviewTotalEl.textContent = usd(o.total);
    reviewBreakdownEl.innerHTML = `Island ${usd(o.islandSubtotal)} <span class="ma-cfg__hero-dot" aria-hidden="true">·</span> Accessories ${usd(o.accessoriesSubtotal)}`;
    showReviewMsg("", false);
    renderUpsell();
  }

  // Cross-finish upsell: only on an Original build, only where a Deluxe/Black
  // equivalent is actually buildable. A suggestion, never a blocker.
  function renderUpsell() {
    upsellEl.hidden = true; upsellEl.innerHTML = "";
    if (!ready()) return;
    // Item 5: after an upgrade, show an explicit undo back to the PRE-upgrade series
    // (only the series they were actually on — no arbitrary downsell). Replaces the
    // upsell cards while active so the customer always has a clear way back.
    if (preUpgradeFinish && preUpgradeFinish !== state.finish && FINISHES[preUpgradeFinish]) {
      const wasLabel = FINISHES[preUpgradeFinish].label || preUpgradeFinish;
      upsellEl.hidden = false;
      upsellEl.innerHTML = `<p class="ma-upsell__head">Upgraded to ${esc(FINISHES[state.finish]?.label || state.finish)}</p>
        <button type="button" class="ma-upsell__revert" data-revert>← Back to ${esc(wasLabel)}</button>`;
      return;
    }
    if (state.finish !== "Original") return;
    const baseTotal = resolver.resolveBuild(sel()).total || 0;
    const cards = [];
    for (const tf of ["Deluxe", "Black"]) {
      const b = resolver.resolveBuild({ ...sel(), finish: tf });
      if (!b || b.mode === "unbuildable" || !b.lines.length || !b.lines[0].variantId) continue;
      const incl = ((FINISHES[tf] && FINISHES[tf].includes) || []).join(", ") + (tf === "Deluxe" ? ", waterfall granite composite ends" : "");
      const delta = b.total != null ? b.total - baseTotal : null;
      cards.push(`<button type="button" class="ma-upsell__card" data-switch="${tf}">
        <span class="ma-upsell__body"><span class="ma-upsell__title">Upgrade to ${esc((FINISHES[tf] && FINISHES[tf].label) || tf)}</span>
        <span class="ma-upsell__sub">Includes ${esc(incl)}</span></span>
        <span class="ma-upsell__delta">${delta != null ? (delta >= 0 ? `+${usd(delta)}` : usd(delta)) : ""}</span></button>`);
    }
    if (!cards.length) return;
    upsellEl.hidden = false;
    upsellEl.innerHTML = `<p class="ma-upsell__head">Want more included? Switch series</p>${cards.join("")}`;
  }

  const showReviewMsg = (text, isError) => { reviewMsgEl.hidden = !text; reviewMsgEl.textContent = text; reviewMsgEl.classList.toggle("is-error", !!isError); };

  // Multi-line add-to-cart: every line by its real variant ID (resolved now, live).
  // Fail loud if any line can't resolve — never add a partial cart.
  async function addToCart() {
    const o = composeOrder();
    if (!o.cartLines.length) { showReviewMsg("Build isn’t complete yet.", true); return; }
    if (o.unresolved.length) { showReviewMsg(`Couldn’t resolve a variant for: ${o.unresolved.join(", ")}. Nothing was added.`, true); return; }
    // Build-source tagging: one _build_id per configured order (same on every line so the lines of one
    // build can be grouped); _build_source flags the configurator path. Underscore-prefixed = private
    // (hidden from the customer in cart/checkout, but persists onto the order line items). Adds props
    // only — variant resolution, multi-line composition, MANGK NG line, $0 gift Bonus, and totals unchanged.
    const buildId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
    const items = o.cartLines.map((l) => {
      const properties = { _build_source: "configurator", _build_id: buildId };
      if (l.free) properties["Bonus"] = l.kind === "gift" ? "Free gift" : "Included with Natural Gas";
      return { id: Number(l.variantId), quantity: 1, properties };
    });
    addBtn.disabled = true; showReviewMsg("Adding to cart…", false);
    try {
      const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
      if (!res.ok) { const t = await res.text(); throw new Error(`${res.status} ${t.slice(0, 160)}`); }
      showReviewMsg("Added ✓ Taking you to your cart…", false);
      window.location.href = "/cart";
    } catch (e) {
      addBtn.disabled = false;
      showReviewMsg(`Add to cart failed — ${e.message}. Nothing was added.`, true);
    }
  }

  // ---- reachability / pricing ----------------------------------------------
  function recompute() {
    renderHero();
    renderDimensions();
    renderSpecs();
    const gated = ready();

    sizesEl.querySelectorAll(".ma-opt").forEach((el) => {
      const v = Number(el.dataset.size);
      const reachable = state.finish ? resolver.baseExists(state.finish, v, state.shape) : true;
      off(el, !reachable); el.setAttribute("aria-pressed", String(state.size === v));
      const ps = el.querySelector("[data-price]"); const t = buildFor({ size: v }).total;
      ps.textContent = reachable ? (t != null ? usd(t) : "") : "Unavailable"; ps.className = reachable ? "ma-opt__price" : "ma-opt__na";
    });
    shapesEl.querySelectorAll(".ma-opt").forEach((el) => {
      const v = el.dataset.shape;
      const reachable = gated ? resolver.baseExists(state.finish, state.size, v) : false;
      off(el, !reachable); setTip(el, !gated ? GATE_TIP : ""); el.setAttribute("aria-pressed", String(state.shape === v));
      const ps = el.querySelector("[data-price]"); const t = gated && reachable ? buildFor({ shape: v }).total : null;
      ps.textContent = !gated ? "" : reachable ? (t != null ? usd(t) : "") : "Unavailable"; ps.className = reachable ? "ma-opt__price" : "ma-opt__na";
    });

    // Cabinet (FC)
    const fcInfo = state.finish ? resolver.moduleInfo(state.finish, "FC") : { available: false };
    cabinetEl.querySelectorAll(".ma-cab").forEach((el) => {
      const fridge = el.dataset.cab === "fridge";
      el.setAttribute("aria-pressed", String(fridge === state.modules.includes("FC")));
      if (!fridge) { off(el, !gated); setTip(el, !gated ? GATE_TIP : ""); return; }
      off(el, !(gated && fcInfo.available)); setTip(el, !gated ? GATE_TIP : "");
      const im = el.querySelector("[data-thumb]"); const tsrc = moduleImage(state.finish, "FC");
      if (im && tsrc && im.getAttribute("src") !== tsrc) im.src = tsrc;  // color-matched fridge image
      fillTip(el, modTip(state.finish, "FC"));  // item 3: fridge-cabinet tooltip
      const sub = el.querySelector("[data-sub]"); const delta = el.querySelector("[data-price]");
      if (gated && !fcInfo.available) { sub.textContent = fcInfo.message || ""; delta.textContent = ""; }
      else { sub.textContent = "Built-in fridge replaces the storage cabinet";
        const d = gated ? buildFor({ modules: withFC(state.modules) }).total - buildFor({ modules: withoutFC(state.modules) }).total : null;
        delta.textContent = d ? `+${usd(d)}` : ""; }
    });

    [refEl, storageEl].forEach((group) => group.querySelectorAll(".ma-mod").forEach((el) => {
      const m = el.dataset.mod; const info = state.finish ? resolver.moduleInfo(state.finish, m) : { available: false };
      const im = el.querySelector("[data-thumb]"); const tsrc = moduleImage(state.finish, m);
      if (im && tsrc && im.getAttribute("src") !== tsrc) im.src = tsrc;  // color-matched module image
      fillTip(el, modTip(state.finish, m));  // item 3: color-matched tooltip image + explainer
      const on = state.modules.includes(m);
      const blocked = gated && !info.available;
      off(el, !gated || blocked); setTip(el, !gated ? GATE_TIP : ""); el.setAttribute("aria-pressed", String(on));
      el.classList.toggle("ma-mod--blocked", blocked);
      const sub = el.querySelector("[data-sub]"); const ps = el.querySelector("[data-price]");
      if (blocked) { sub.textContent = info.message || "Not available in this finish."; ps.textContent = ""; }
      else {
        sub.textContent = MOD_SUB[m] || "";
        const withM = state.modules.includes(m) ? state.modules : [...state.modules, m];
        const withoutM = state.modules.filter((x) => x !== m);
        const d = gated ? buildFor({ modules: withM }).total - buildFor({ modules: withoutM }).total : null;
        ps.textContent = gated && d ? (on ? "" : "+") + usd(d) : "";
      }
    }));

    if (fuelEl) fuelEl.querySelectorAll(".ma-fuel__opt").forEach((el) => el.setAttribute("aria-pressed", String(el.dataset.fuelopt === state.fuel)));

    renderGift(); renderAccessories(); renderReview();

    setDone("finish", !!state.finish); setDone("sizeshape", !!state.size);
    setDone("refstorage", state.modules.length > 0);
    setDone("accessories", !!state.gift || state.accessories.length > 0 || state.cover);
    setDone("review", ready());
    saveState();   // item 7: persist after every change
  }
  const setDone = (step, done) => { const b = stepBtns.find((s) => s.dataset.step === step); if (b) b.dataset.done = String(done); };

  // ---- item 7: build persistence via localStorage (best-effort) -------------
  // This is a live Shopify theme page (not a sandboxed artifact), so localStorage
  // is available. Save the build on every recompute; restore + validate on load.
  // Any failure (private mode, quota, malformed) is swallowed — losing the build
  // on refresh is acceptable, so we never block the configurator on storage.
  function saveState() {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify({
        finish: state.finish, size: state.size, shape: state.shape, modules: state.modules,
        fuel: state.fuel, gift: state.gift, accessories: state.accessories, cover: state.cover,
      }));
    } catch (e) { /* storage unavailable — best-effort only */ }
  }
  function restoreState() {
    let saved;
    try { saved = JSON.parse(localStorage.getItem(LS_KEY) || "null"); } catch (e) { return false; }
    if (!saved || typeof saved !== "object" || !saved.finish || !FINISHES[saved.finish]) return false;
    state.finish = saved.finish;
    if (saved.size === 4 || saved.size === 6) state.size = saved.size;
    if (["Straight", "L", "V"].includes(saved.shape)) state.shape = saved.shape;
    state.modules = Array.isArray(saved.modules) ? saved.modules.filter((m) => MODULE_DEFS[m]) : [];
    if (saved.fuel === "ng" || saved.fuel === "propane") state.fuel = saved.fuel;
    state.gift = typeof saved.gift === "string" ? saved.gift : null;
    state.accessories = Array.isArray(saved.accessories) ? saved.accessories.filter((s) => typeof s === "string") : [];
    state.cover = saved.cover === true;
    return true;   // a finish was restored — repairState() below prunes anything invalid for it
  }

  // ---- handlers -------------------------------------------------------------
  finishesEl.addEventListener("click", (e) => {
    const b = e.target.closest(".ma-finish"); if (!b) return;
    state.finish = b.dataset.finish;
    preUpgradeFinish = null;   // a deliberate finish choice clears the upgrade-undo
    finishesEl.querySelectorAll(".ma-finish").forEach((x) => x.setAttribute("aria-pressed", String(x === b)));
    adjustMsg = repairState(); recompute();
  });
  sizesEl.addEventListener("click", (e) => { const b = e.target.closest(".ma-opt"); if (!b || isOff(b)) return; state.size = Number(b.dataset.size); adjustMsg = ""; recompute(); });
  shapesEl.addEventListener("click", (e) => { const b = e.target.closest(".ma-opt"); if (!b || isOff(b)) return; state.shape = b.dataset.shape; adjustMsg = ""; recompute(); });
  cabinetEl.addEventListener("click", (e) => { if (handleTip(e)) return; const b = e.target.closest(".ma-cab"); if (!b || isOff(b)) return; state.modules = b.dataset.cab === "fridge" ? withFC(state.modules) : withoutFC(state.modules); adjustMsg = ""; recompute(); });
  [refEl, storageEl].forEach((g) => g.addEventListener("click", (e) => { if (handleTip(e)) return; const b = e.target.closest(".ma-mod"); if (!b || isOff(b)) return; state.modules = toggleSet(state.modules, b.dataset.mod); adjustMsg = ""; recompute(); }));
  if (fuelEl) fuelEl.addEventListener("click", (e) => { const b = e.target.closest(".ma-fuel__opt"); if (!b) return; state.fuel = b.dataset.fuelopt; adjustMsg = ""; recompute(); });
  // Gift = single-pick radio (tap again to clear). Accessories = multi-toggle.
  giftOptsEl.addEventListener("click", (e) => { if (handleTip(e)) return; const b = e.target.closest(".ma-gift__opt"); if (!b) return; const sku = b.dataset.giftsku; state.gift = state.gift === sku ? null : sku; recompute(); });
  accEl.addEventListener("click", (e) => { if (handleTip(e)) return; const b = e.target.closest(".ma-acc"); if (!b) return; if (b.dataset.cover) state.cover = !state.cover; else state.accessories = toggleSet(state.accessories, b.dataset.accsku); recompute(); });
  // Review: cross-finish upsell switch (re-resolves the build), reversible undo, + add-to-cart.
  const syncFinishTiles = () => finishesEl.querySelectorAll(".ma-finish").forEach((x) => x.setAttribute("aria-pressed", String(x.dataset.finish === state.finish)));
  upsellEl.addEventListener("click", (e) => {
    if (e.target.closest("[data-revert]")) {                  // item 5: undo the upgrade
      if (preUpgradeFinish) { state.finish = preUpgradeFinish; preUpgradeFinish = null; adjustMsg = repairState(); syncFinishTiles(); recompute(); }
      return;
    }
    const b = e.target.closest("[data-switch]"); if (!b) return;
    preUpgradeFinish = state.finish;                          // remember where we came from, for the undo
    state.finish = b.dataset.switch; adjustMsg = repairState(); syncFinishTiles(); recompute();
  });
  if (addBtn) addBtn.addEventListener("click", () => addToCart());

  // Drop modules the new finish genuinely can't offer; reset an unavailable shape.
  function repairState() {
    if (!ready()) return "";
    const dropped = state.modules.filter((m) => !resolver.moduleInfo(state.finish, m).available);
    if (dropped.length) state.modules = state.modules.filter((m) => resolver.moduleInfo(state.finish, m).available);
    let shapeReset = false;
    if (!resolver.baseExists(state.finish, state.size, state.shape) && state.shape !== "Straight") { state.shape = "Straight"; shapeReset = true; }
    if (!dropped.length && !shapeReset) return "";
    const names = dropped.map((m) => MODULE_DEFS[m]?.label || m);
    if (shapeReset) names.push("that layout");
    return `<strong>${esc(FINISHES[state.finish].label)}</strong> doesn’t offer ${esc(names.join(", "))} — removed from your build.`;
  }

  // ---- nav (free-tab + sequential Prev/Next + reset) ------------------------
  // Mobile-only step nav (under the tabs); shares activate()/TAB_ORDER — no separate state.
  const mStepPrev = $('[data-stepnav="prev"]'), mStepNext = $('[data-stepnav="next"]');
  function activate(step) {
    stepBtns.forEach((s) => s.setAttribute("aria-selected", String(s.dataset.step === step)));
    panels.forEach((p) => (p.dataset.active = String(p.dataset.panel === step)));
    const i = TAB_ORDER.indexOf(step);
    const atFirst = i <= 0, atLast = i >= TAB_ORDER.length - 1;
    navPrev.disabled = atFirst; navNext.disabled = atLast;
    if (mStepPrev) mStepPrev.disabled = atFirst;
    if (mStepNext) mStepNext.disabled = atLast;
  }
  const current = () => TAB_ORDER[Math.max(0, TAB_ORDER.findIndex((s) => stepBtns.find((b) => b.dataset.step === s)?.getAttribute("aria-selected") === "true"))];
  const goPrev = () => { const i = TAB_ORDER.indexOf(current()); if (i > 0) activate(TAB_ORDER[i - 1]); };
  const goNext = () => { const i = TAB_ORDER.indexOf(current()); if (i < TAB_ORDER.length - 1) activate(TAB_ORDER[i + 1]); };
  stepBtns.forEach((s) => s.addEventListener("click", () => activate(s.dataset.step)));
  navPrev.addEventListener("click", goPrev);
  navNext.addEventListener("click", goNext);
  if (mStepPrev) mStepPrev.addEventListener("click", goPrev);
  if (mStepNext) mStepNext.addEventListener("click", goNext);
  navReset.addEventListener("click", () => {
    state.finish = null; state.size = DEFAULTS.size; state.shape = DEFAULTS.shape; state.modules = []; state.fuel = DEFAULTS.fuel; state.gift = null; state.accessories = []; state.cover = false; adjustMsg = ""; preUpgradeFinish = null;
    finishesEl.querySelectorAll(".ma-finish").forEach((x) => x.setAttribute("aria-pressed", "false"));
    activate("finish"); recompute();
  });

  // item 7: restore a saved build (if any) before first paint, then prune anything
  // the restored finish can't actually offer and sync the finish tiles.
  if (restoreState()) { adjustMsg = repairState(); syncFinishTiles(); }
  activate("finish");
  renderModuleExplainer();   // build-independent — render once
  recompute();
})();
